import * as React from "react";
import qs from "qs";
import { useNavigate } from "react-router-dom";
import {
	Box,
	Typography,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Checkbox,
	FormControlLabel,
	FormHelperText,
} from "@mui/material";
import { useSelector,  useDispatch} from "../../../../store";
import { submitLearner } from "../../../../store/slices/learner";

import RedirectButton from "../../../ui-components/Buttons/RedirectButton";
import CourseSelectionDropdown from "../../../ui-components/CourseSelectionDropdown";
import validator from 'validator'

export default function MobileForm() {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = React.useState(false);
	const learnerState = useSelector((state) => state.learner || {});
	const clientState = useSelector((state) => state.client || {});
	const [learnerDetails, setLearnerDetails] = React.useState({});
	const [learnerForm, setLearnerForm] = React.useState([]);
	const [customForm, setCustomForm] = React.useState({});
	const [formError, setFormError] = React.useState({});
	const publicUrl = process.env.PUBLIC_URL;

	React.useEffect(() => {
		const learner = learnerState.details || {};
		const learnerId = learner?.learnerId || "";
		setLearnerDetails({
			firstname: learner?.name?.first || "",
			lastname: learner?.name?.last || "",
			email: learner?.email || "",
			learnerId: learnerId === "skipped" ? "" : learnerId,
			selectedCourseIdComparison: learner?.selectedCourseIdComparison || "default",
			testLevel: learner?.testLevel || "",
		});
		if ((learner?.details || []).length > 0) {
			let customFormInital = {};
			learner.details.forEach((f) => {
				customFormInital = {
					...customFormInital,
					[f.formElement]: f.value,
				};
			});
			setCustomForm(customFormInital);
		}
	}, [learnerState]);

	React.useEffect(() => {
		const customForm = clientState?.details?.learnerForm || [];
		const activeForm = customForm.filter((form) => form.hidden !== true);
		// if (activeForm.length > 0) {
		// 	let customFormInital = {};
		//     activeForm.forEach((f) => {
		// 		customFormInital = { ...customFormInital, [f._id]: null };
		// 	});
		// 	setCustomForm(customFormInital);
		// }
		setLearnerForm(activeForm);
		return () => {};
	}, [clientState]);

	const { quizId } = qs.parse(window.location.search, {
		ignoreQueryPrefix: true,
	});

	const handleSubmitLearner = async () => {
		let error = {};
		if (!learnerDetails?.firstname) {
			error = { firstname: true };
		}
		if (!learnerDetails?.lastname) {
			error = { ...error, lastname: true };
		}
		if (!learnerDetails?.email) {
			error = { ...error, email: true };
		} else if (!validator.isEmail(learnerDetails?.email)) {
			error = { ...error, email: true };
		}

		learnerForm.forEach((lf) => {
			const isRequired = lf?.validation?.required || false;
			if (isRequired) {
				if (lf.fieldtype === "boolean") {
					if (typeof customForm[lf._id] === "undefined" || customForm[lf._id] === undefined || customForm[lf._id] === '' || customForm[lf._id] === false) {
						error[lf._id] = true;
					}
				} else {
					if (typeof customForm[lf._id] === "undefined" || customForm[lf._id] === '') {
						error[lf._id] = true;
					}
				}
			}
		});

		setFormError(error);
		if (Object.keys(error).length > 0) {
			return false;
		}
		setIsLoading(true);

		const inviteCode = await dispatch(
			submitLearner({ ...learnerDetails }, customForm, quizId)
		);
		setIsLoading(false);
		navigate(`${publicUrl}/declaration?invite=${inviteCode}`);
	};

	return (
		<React.Fragment>
			<Box
				sx={{	
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
				<Typography
					variant="h6_bold"
					sx={{
						display: "flex",
						justifyContent: "center",
						mt: 1,
						mb: 2,
						color: "#06b6ad",
					}}
				>
					Your Details
				</Typography>

				<TextField
					label="Learner ID"
					fullWidth
					variant="standard"
					size="large"
					sx={{ mb: 1 }}
					value={learnerDetails?.learnerId || ""}
					onChange={(e) =>
						setLearnerDetails({
							...learnerDetails,
							learnerId: e.target.value.replaceAll("’", "'"),
						})
					}
					disabled={learnerState.details?.inviteCode && 
						learnerState?.details?.learnerId !== '' &&
						learnerState?.details?.learnerId !== 'skipped'
						? true : false}
				/>
				<TextField
					label="First Name"
					required
					fullWidth
					variant="standard"
					size="large"
					error={formError?.firstname}
					helperText={
						formError.firstname ? "First name is required." : ""
					}
					sx={{ mb: 2 }}
					value={learnerDetails?.firstname || ""}
					onChange={(e) =>
						setLearnerDetails({
							...learnerDetails,
							firstname: e.target.value.replaceAll("’", "'"),
						})
					}
				/>

				<TextField
					label="Last Name"
					required
					fullWidth
					variant="standard"
					size="large"
					sx={{ mb: 1 }}
					error={formError?.lastname}
					helperText={
						formError.lastname ? "Last name is required." : ""
					}
					value={learnerDetails?.lastname || ""}
					onChange={(e) =>
						setLearnerDetails({
							...learnerDetails,
							lastname: e.target.value.replaceAll("’", "'"),
						})
					}
				/>

				<TextField
					label="Email"
					required
					type="email"
					fullWidth
					variant="standard"
					size="large"
					error={formError?.email}
					helperText={formError.email ? "Invalid Email." : ""}
					sx={{ mb: 1 }}
					value={learnerDetails?.email || ""}
					onChange={(e) =>
						setLearnerDetails({
							...learnerDetails,
							email: e.target.value.replaceAll("’", "'"),
						})
					}
					disabled={learnerState?.details &&
						learnerState.details?.inviteCode &&
						learnerState?.details?.email !== "" ?
						true : false}
				/>
				{/* CUSTOM FORM */}
				{learnerForm.map((form) => {
					switch (form.fieldtype) {
						case "boolean":
							return (
								<FormControl
									error={
										typeof formError[form._id] !==
										"undefined"
									}
									key={`custom-form-${form._id}`}
								>
									<FormControlLabel
										control={
											<Checkbox
												color="primary"
												checked={
													customForm[form._id] ===
													true
												}
												onChange={(e) =>
													setCustomForm({
														...customForm,
														[form._id]:
															e.target.checked,
													})
												}
												sx={{
													mb: 0,
													color:
														typeof formError[
															form._id
														] !== "undefined"
															? "#d32f2f"
															: "rgba(0, 0, 0, 0.87)",
												}}
											/>
										}
										label={form.label}
										sx={{
											mb: 0,
											color:
												typeof formError[form._id] !==
												"undefined"
													? "#d32f2f"
													: "rgba(0, 0, 0, 0.87)",
										}}
									/>
									{typeof formError[form._id] !==
										"undefined" && (
										<FormHelperText sx={{ m: 0, mb: 0.5 }}>
											{form.label} is required.
										</FormHelperText>
									)}
								</FormControl>
							);
						case "select":
							return (
								<FormControl
									error={
										typeof formError[form._id] !==
										"undefined"
									}
									fullWidth
									sx={{ mb: 1 }}
									key={`custom-form-${form._id}`}
								>
									<InputLabel>{form.label}</InputLabel>
									<Select
										label={form.label}
										value={customForm[form._id] || ""}
										onChange={(e) =>
											setCustomForm({
												...customForm,
												[form._id]:
													e.target.value.replaceAll(
														"’",
														"'"
													),
											})
										}
									>
										{form.validation.enum.map((selVal) => (
											<MenuItem
												key={`select-value-${selVal}`}
												value={selVal}
											>
												{selVal}
											</MenuItem>
										))}
									</Select>
									{typeof formError[form._id] !==
										"undefined" && (
										<FormHelperText sx={{ ml: 0 }}>
											{form.label} is required.
										</FormHelperText>
									)}
								</FormControl>
							);
						default:
							return (
								<TextField
									key={`custom-form-${form._id}`}
									label={form.label}
									fullWidth
									variant="standard"
									size="large"
									sx={{ mb: 1 }}
									error={
										typeof formError[form._id] !==
										"undefined"
									}
									helperText={
										typeof formError[form._id] !==
										"undefined"
											? `${form.label} is required.`
											: ""
									}
									value={customForm[form._id] || ""}
									onChange={(e) =>
										setCustomForm({
											...customForm,
											[form._id]:
												e.target.value.replaceAll(
													"’",
													"'"
												),
										})
									}
								/>
							);
					}
				})}
				{quizId !== 'vfh' && clientState?.details?.preferences?.learnerPreEnrollmentReport && (
          			<CourseSelectionDropdown onChange={(value) =>
						setLearnerDetails({
							...learnerDetails,
							selectedCourseIdComparison: value,
						})} 
						value={learnerDetails.selectedCourseIdComparison || "default"}
						inputLabelStyle={{left: "-12px"}}
					/>
        		)}
				<RedirectButton
					// url="/declaration"
					title="SUBMIT"
					disabled={isLoading}
					handleClick={() => handleSubmitLearner()}
				/>
			</Box>
		</React.Fragment>
	)
}